import {fromJS} from 'immutable';
const initPlantData = fromJS({})


export function plantData(
  state = initPlantData,
  action
) {
  switch (action.type) {
    case "PLANT_FETCH_DATA_SUCCESS":
      return fromJS(action.dataPlant);
    default:
      return state;
  }
}
